import CreateEntity, { CreateEntityField } from "./CreateEntity";
import { API_BASE_URL } from "../utils/api";

interface Game {
  game_id: string;
  game_name: string;
  max_turns: number;
  current_turn: number;
  game_status: string;
}

interface CreateTeamFormProps {
  game: Game;
  onClose?: () => void;
  onSuccess?: () => void;
}

export default function CreateTeamForm({ game, onClose, onSuccess }: CreateTeamFormProps) {
  const fields: CreateEntityField[] = [
    { name: "team_name", label: "Team Name", type: "text", placeholder: "Enter team name" },
    { name: "team_code_name", label: "Team Code Name", type: "text", placeholder: "Enter team code name" }
  ];

  const handleSubmit = async (values: Record<string, string>) => {
    const teamName = values.team_name?.trim() ?? "";
    const teamCodeName = values.team_code_name?.trim() ?? "";

    if (!teamName) {
      throw new Error("Team name is required");
    }
    if (!teamCodeName) {
      throw new Error("Team code name is required");
    }

    const res = await fetch(`${API_BASE_URL}/teams/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        team_name: teamName,
        team_code_name: teamCodeName,
        game_name: game.game_name
      })
    });

    if (!res.ok) {
      const errBody = await res.json().catch(() => ({}));
      throw new Error(errBody.detail || "Failed to create team");
    }

    const data = await res.json();

    if (onSuccess) {
      onSuccess();
    }

    return { successMessage: `Team "${data.team_name}" created successfully!` };
  };

  return (
    <div>
      <CreateEntity
        title={`Create Team for ${game.game_name}`}
        fields={fields}
        onSubmit={handleSubmit}
        onClose={onClose}
        submitLabel="Create Team"
      />
      <div
        style={{
          marginTop: "0.75rem",
          padding: "0.75rem",
          backgroundColor: "#e9ecef",
          borderRadius: "4px",
          fontSize: "0.875rem",
          color: "#6c757d"
        }}
      >
        <strong>Game:</strong> {game.game_name} (will be automatically associated)
      </div>
    </div>
  );
}


